<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>

<script>
import Emitter from '../../mixins/emitter'
const PREFIX_CLASS = 'radio-group'

export default {
  name: 'TRadioGroup',
  provide() {
    return {
      groupVM: this
    }
  },
  mixins: [Emitter],
  props: {
    value: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '',
      validator(val) {
        /* istanbul ignore next */
        return ['lg', 'sm', ''].includes(val)
      }
    },
    type: {
      type: String,
      default: '',
      validator(val) {
        /* istanbul ignore next */
        return ['button', ''].includes(val)
      }
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: this.value
    }
  },
  computed: {
    classes() {
      return [
        PREFIX_CLASS,
        {
          [`${PREFIX_CLASS}--${this.size}`]: !!this.size,
          [`${PREFIX_CLASS}-${this.type}`]: !!this.type,
          [`${PREFIX_CLASS}-inline`]: !this.vertical
        }
      ]
    },
    prop () {
      let parent = this.$parent
      while (parent && parent.$options && parent.$options.name !== 'TFormItem') {
        parent = parent.$parent
      }
      return (parent && parent.prop) || ''
    }
  },
  watch: {
    value(newVal) {
      this.currentValue = newVal
    }
  },
  methods: {
    $_onChange(value) {
      this.currentValue = value
      this.$_emitEvents(value)
    },
    $_emitEvents(value) {
      this.$emit('input', value)
      this.$emit('change', value)
      // NOTE: 用于form验证
      this.dispatch('TFormItem', 'g-on-form-change', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/radio/radio-group.vue